export default {
  'sign.out': {
    ko: '로그아웃',
    ja: 'ログアウト',
    en: 'Logout',
    cn: '',
  },
  'sign.in': {
    ko: '로그인',
    ja: 'ログイン',
    en: 'login',
    cn: '',
  },
  'security.access.denied': {
    ko: '접근 권한이 없습니다.',
    ja: 'アクセス権限がありません。',
    en: 'Access denied.',
    cn: '',
  },
};
